import { IIconBase } from '..'

const buyIcon = ({ color = '#333752', height = 24, width = 25 }: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/3d-rotate'>
        <g id='3d-rotate'>
          <g id='Group'>
            <g id='Group_2'>
              <path
                id='Vector'
                d='M7.2002 11.2598L12.5002 14.3298L17.7602 11.2798'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                id='Vector_2'
                d='M12.5 19.7698V14.3198'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <path
              id='Vector_3'
              d='M11.2603 8.28973L8.06024 10.0697C7.34024 10.4697 6.74023 11.4797 6.74023 12.3097V15.6997C6.74023 16.5297 7.33024 17.5397 8.06024 17.9397L11.2603 19.7197C11.9403 20.0997 13.0602 20.0997 13.7502 19.7197L16.9503 17.9397C17.6703 17.5397 18.2702 16.5297 18.2702 15.6997V12.2997C18.2702 11.4697 17.6803 10.4597 16.9503 10.0597L13.7502 8.27973C13.0602 7.89973 11.9403 7.89973 11.2603 8.28973Z'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <g id='Group_3'>
            <path
              id='Vector_4'
              d='M17.3991 6.00027C14.6909 3.23577 10.2646 3.19024 7.50009 5.89845L9.47479 6.41377'
              stroke='#842029'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default buyIcon
